const serviceInfo = {
    0: {
        name: 'one_off_rate',
        weeks: 1,
        fee: 1
    },
    1: {
        name: 'three_months_rate',
        weeks: 13,
        fee: 79
    },
    2: {
        name: 'six_months_rate',
        weeks: 26,
        fee: 109
    },
    3: {
        name: 'yearly_rate',
        weeks: 52,
        fee: 189
    }
};

$(document).ready(function () {
    $('.clean-frequency-btn').on('click', function () {
        const btnVal = $(this).val();
        const btnValMultiplier = $(this).data('frequency');
        $('.clean-frequency-btn').removeClass('active');
        $(this).addClass('active');
        $('#frequency-input')
            .val(btnVal);
        $('#frequency-multiplier')
            .val(btnValMultiplier);

        if (btnVal == 'one-time') {
            $('.service-lenght .rangeslider').addClass('rangeslider--disabled');
        } else {
            $('.service-lenght .rangeslider').removeClass('rangeslider--disabled');
        }

        $('#frequency-input')
            .trigger('change');
    });

    $('#frequency-input, #service-lenght, #service-hours').on('change', function () {
        const serviceFrequency = $('#frequency-input');
        const serviceFrequencyMultiplier = $('#frequency-multiplier');
        const serviceHours = $('#service-hours').val();

        const cleanerHourlyRate = $('#cleaner-hourly-rate').val();

        const serviceLenght = getServiceLenght(serviceFrequency.val());
        const serviceLenghtInWeeks = serviceInfo[serviceLenght].weeks;

        const serviceFee = getServiceFee(serviceLenght);
        
        const hourlyRate = getHourlyRate(
            parseInt(serviceFee),
            parseFloat(serviceFrequencyMultiplier.val()),
            parseInt(serviceLenghtInWeeks),
            parseInt(serviceHours),
            cleanerHourlyRate
        );

        $('.per-hour-quotation').text(`£${hourlyRate}`);
    });

    initialValue();
});

function initialValue()
{
    $('#frequency-input')
        .trigger('change');
}

function getServiceFee(serviceLenght)
{
    const serviceFeeRateId = serviceInfo[serviceLenght].name;
    const serviceFee = $('#' + serviceFeeRateId).val();
    const serviceFeeSanitized = serviceFee.replace(/[^\d.-]/g, '');
    return parseFloat(serviceFeeSanitized)
}

function getServiceLenght(serviceFrequencyVal)
{
    if (serviceFrequencyVal === 'one-time') {
        return 0;
    }
    return $('#service-lenght').val();
}

function getHourlyRate(
    serviceFree,
    serviceFrequency,
    serviceLenghts,
    serviceHours,
    cleanerHourlyRate
) {
    console.log('=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-');
    console.log('serviceFree', serviceFree);
    console.log('serviceFrequency', serviceFrequency);
    console.log('serviceLenghts', serviceLenghts);
    console.log('serviceHours', serviceHours);
    console.log('cleanerHourlyRate', cleanerHourlyRate);
    const cleanerHourlyRateSanitized = cleanerHourlyRate.replace(/[^\d.-]/g, '');
    const hourlyRate = (serviceFree / (serviceLenghts * serviceFrequency)) / serviceHours + parseFloat(cleanerHourlyRateSanitized);

    return hourlyRate.toFixed(2);
}
